import { Injectable } from '@angular/core';
import { first,Observable } from 'rxjs';

import { Store } from '@ngrx/store';

import { LoginMethod } from '@personal-area/global/authorization/models';
import { DataLayer } from '@personal-area/global/gtm';

import {
  SetEventDispatchStatus,
  SetIsLoginAfterRegistration,
  SetLoginMethod,
  SetUserData,
} from '../actions/login-analytics.actions';
import { LoginAnalyticsState } from '../reducers/login-analytics.reducers';
import {
  getLoginAnalyticsData,
  getLoginAnalyticsMethod,
} from '../selectors/login-analytics.selectors';

@Injectable({ providedIn: 'root' })
export class LoginAnalyticsFacade {
  constructor(private _store: Store) {}

  public setUserData(user: DataLayer['user']): void {
    this._store.dispatch(SetUserData({ user }));
  }

  public setLoginMethod(method: LoginMethod): void {
    this._store.dispatch(SetLoginMethod({ method }));
  }

  public setIsLoginAfterRegistration(isLoginAfterRegistration: boolean): void {
    this._store.dispatch(
      SetIsLoginAfterRegistration({ isLoginAfterRegistration }),
    );
  }

  public setEventDispatchStatus(isEventSent: boolean): void {
    this._store.dispatch(SetEventDispatchStatus({ isEventSent }));
  }

  public setLoginMethodFromLoginData(method: LoginMethod): void {
    this.getLoginMethod()
      .pipe(first((prev) => !prev))
      .subscribe(() => this.setLoginMethod(method));
  }

  public getLoginMethod(): Observable<LoginMethod> {
    return this._store.select(getLoginAnalyticsMethod);
  }

  public getLoginAnalyticsData(): Observable<LoginAnalyticsState> {
    return this._store.select(getLoginAnalyticsData);
  }
}
